module.exports = __webpack_public_path__ + "static/media/drag_anchor_w.4c6b7399.svg";